import { useState, useCallback } from "react"

import { LANGUAGE_DE, LANGUAGE_EN } from "../constants"

const useToggleLanguage = (initialValue = LANGUAGE_EN) => {
  const [value, setValue] = useState(initialValue)

  const toggle = useCallback(() => {
    setValue(value === LANGUAGE_DE ? LANGUAGE_EN : LANGUAGE_DE)
  }, [value])

  return [value, toggle]
}

export default useToggleLanguage
